import { Route as ReactRoute } from "react-router-dom";

import { IRoute, IRouteType } from "App/types";
import { PrivateRoute, AuthRoute, AdminRoute } from "App/router";
import { PermissionsRoute } from "./PermissionsRoute";

export const Route = ({ type, Component, ...rest }: IRoute) => {
  switch (type) {
    case IRouteType.permission:
      return <PermissionsRoute component={Component} {...rest} />;
    case IRouteType.private:
      return <PrivateRoute component={Component} {...rest} />;
    case IRouteType.auth:
      return <AuthRoute component={Component} {...rest} />;
    case IRouteType.admin:
      return <AdminRoute component={Component} {...rest} />;
    case IRouteType.public:
    default:
      return <ReactRoute component={Component} {...rest} />;
  }
};
